import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "frame" }
const _hoisted_3 = { class: "frame__inner" }
const _hoisted_4 = { class: "frame__header" }
const _hoisted_5 = { class: "frame__body" }
const _hoisted_6 = {
  key: 1,
  class: "confirm-otp"
}
const _hoisted_7 = { class: "confirm-otp__inner" }
const _hoisted_8 = { class: "confirm-otp__body" }
const _hoisted_9 = { class: "confirm-otp__text confirm-otp__title" }
const _hoisted_10 = { class: "confirm-otp__input" }
const _hoisted_11 = {
  key: 0,
  class: "confirm-otp__text confirm-otp__description"
}
const _hoisted_12 = {
  key: 1,
  class: "confirm-otp__resend"
}
const _hoisted_13 = { class: "confirm-otp__text" }
const _hoisted_14 = { class: "confirm-otp__btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Back = _resolveComponent("Back")!
  const _component_ap_loader = _resolveComponent("ap-loader")!
  const _component_ap_input_mask = _resolveComponent("ap-input-mask")!
  const _component_ap_button = _resolveComponent("ap-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Back, {
            title: _ctx.t('confirmation_code'),
            redirect: _ctx.redirect
          }, null, 8, ["title", "redirect"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_ap_loader, { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('otp.description', {number: _ctx.phoneNumber})), 1),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_ap_input_mask, {
                        modelValue: _ctx.otpInfo.otp,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.otpInfo.otp) = $event)),
                        label: _ctx.t('otp.sms'),
                        type: "otp",
                        "error-text": _ctx.otpErrors,
                        onKeyup: _ctx.keyup
                      }, null, 8, ["modelValue", "label", "error-text", "onKeyup"])
                    ]),
                    (_ctx.showTimer)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('otp.timer', {timer: _ctx.timer})), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('otp.resend')), 1),
                          _createElementVNode("button", {
                            class: "resend-btn",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resendOTP && _ctx.resendOTP(...args)))
                          }, _toDisplayString(_ctx.t('resendOTP')), 1)
                        ])),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_ap_button, {
                        full: true,
                        type: "primary",
                        disable: _ctx.disableBtn,
                        onClick: _ctx.sendOtpInfo
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('confirm')), 1)
                        ]),
                        _: 1
                      }, 8, ["disable", "onClick"])
                    ])
                  ])
                ])
              ]))
        ])
      ])
    ])
  ]))
}